<script setup lang="ts">
import { CirclePlay } from 'lucide-vue-next';
import { useTutorials } from '~/composables/api/useTutorials';

const router = useRouter();
const currentRoute = router.currentRoute;

const { showVideo } = useVideo();
const { getTutorials } = useTutorials();
const { data: allTutorials } = await getTutorials();

const normalizedRoute = computed(() => {
  const pathWithoutLocale = currentRoute.value.path.replace(/^\/(pt|en)(?=\/|$)/, '') || '/';
  if (pathWithoutLocale !== '/' && pathWithoutLocale.endsWith('/')) {
    return pathWithoutLocale.slice(0, -1);
  }
  return pathWithoutLocale;
});

const tutorial = computed(() =>
  allTutorials.value?.find(
    (item: { path: string; title: string; videoUrl: string }) => item.path === normalizedRoute.value
  )
);

const canWatchTutorial = computed(
  () => Boolean(tutorial.value?.title?.trim()) && Boolean(tutorial.value?.videoUrl?.trim())
);

async function videoAppear() {
  if (tutorial.value?.videoUrl)
    await showVideo({
      videoUrl: tutorial.value.videoUrl,
      title: tutorial.value.title
    });
}
</script>
<template>
  <button
    v-if="canWatchTutorial"
    class="p-1 rounded-lg transition-colors hover:bg-gray-100 dark:hover:bg-gray-800/50"
    @click="videoAppear"
  >
    <CirclePlay class="w-5 h-5" />
  </button>
</template>
